
export default {
  data() {
    return {
      statusList: [
        { id: 10, name: '待开票' },
        { id: 20, name: '开票中' },
        { id: 30, name: '待核销' },
        { id: 40, name: '部分核销' },
        { id: 50, name: '核销完成' },
        { id: 60, name: '红冲中' },
        { id: 70, name: '已红冲' },
        { id: 80, name: '已删除' },
        { id: 90, name: '已撤销' }
      ],
      statusObj: {
        10: '待开票',
        20: '开票中',
        30: '待核销',
        40: '部分核销',
        50: '核销完成',
        60: '红冲中',
        70: '已红冲',
        80: '已删除',
        90: '已撤销'
      },
      // 应付提交状态
      payStatusList: [
        { id: 11, name: '待核实' },
        { id: 21, name: '待提交' },
        { id: 31, name: '已提交' },
        { id: 41, name: '已红冲' },
        { id: 80, name: '已删除' },
        { id: 90, name: '已撤销' }
      ],
      payStatusObj: {
        11: '待核实',
        21: '待提交',
        31: '已提交',
        41: '已红冲',
        80: '已删除',
        90: '已撤销'
      },
    }
  },
  created() {
  },
  methods: {
  }
}